export default {
    HEADER_NOT_PROVIDED: 'HEADER_NOT_PROVIDED',
    DEVICE_NOT_AUTHORIZED: 'DEVICE_NOT_AUTHORIZED',
    BEARER_TOKEN_REQUIRED: 'BEARER_TOKEN_REQUIRED',
};
//# sourceMappingURL=authorization.js.map